import { Email } from 'static/classes/Email';

export function AllEmailsViewModel(data){
    var self = this;
    self.type = "AllEmailsViewModel";

    self.rootvm = data.rootvm;
    self.error = ko.observable();

    self.email_template_list = ko.observableArray([]);
    self.email_template_list_open_rate = ko.observableArray([]);
    self.selected_templates = ko.observableArray([]);
    self.emails = ko.observableArray([]);


    self.search_name = ko.observable();
    self.start_date = ko.observable();
    self.end_date = ko.observable();

    self.total_count = ko.observable();
    self.filtered_count = ko.observable(0);
    self.email_open_count = ko.observable(0);
    self.email_click_count = ko.observable(0);
    self.offset = ko.observable(0);
    self.limit = ko.observable(40);

    self.email_open_percent = ko.pureComputed(function(){
        if(self.filtered_count() > 0){
            return Math.round(( self.email_open_count() /self.filtered_count() ) * 100)
        }
    });
    self.email_click_percent = ko.pureComputed(function(){
        if(self.filtered_count() > 0){
            return Math.round(( self.email_click_count() /self.filtered_count() ) * 100)
        }
    });

    self.email_open_color = ko.pureComputed(function(){

    });

    self.gift_card_report = ko.observableArray([]);
    self.raw_gift_card_report = ko.observableArray([]);

    self.initialized = ko.observable(false);
    self.initialize = function(){

        if (!self.initialized()){

          if (self.offset() == undefined){
                self.offset(0);
          }
          if (self.limit() == undefined){
                self.limit(50);
          }

            const today = new Date();
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(today.getDate() - 7);
            self.start_date(sevenDaysAgo.toLocaleDateString('en-ca'));
            self.end_date(today.toLocaleDateString('en-ca'));


          self.lookup_email_template_list().then(function(){
            self.initialized(true);
          });

          /*self.lookup_emails().then(function(){
                console.log('done looking up gift cards');
          })};*/
        }
    }

    self.show_hidden = ko.observable(false);

    self.editing_extra_comment = ko.observable(undefined);
    self.new_extra_comment = ko.observable(undefined);
    self.cancel_extra_comment = function(){
        self.editing_extra_comment(undefined);
    }

    self.save_extra_comment = function(row, element){
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/gift-report/extra-comment',
            type: 'POST',
            data:ko.toJSON({
                year: self.editing_extra_comment(),
                extra_comment: self.new_extra_comment()
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   row.extra_comment = self.new_extra_comment();

                    $(element)[0].currentTarget.parentElement.previousElementSibling.childNodes[1].innerText = self.new_extra_comment();
                   self.new_extra_comment(undefined);
                   self.editing_extra_comment(undefined);

                   notyf.success("Saved!");
               }
               else{
                   notyf.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
                notyf.error(response.message);
            },
            complete: function(){
            }
        });
    };
    self.lookup_email_template_list  = function(){
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/email-template-list',
            type: 'GET',

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                self.email_template_list(data.email_template_list);
            },
            error: function (data) {
                self.error(data.statusText);
            }
        });

    };

    self.lookup_email_template_open_rate  = function(){
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/email-template-list-open-rate',
            type: 'GET',

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                self.email_template_list_open_rate(ko.utils.arrayMap(
                    data.email_template_list || [],
                    function(x){
                        x.percent = Math.round((x.sum / x.count) * 100);

                        x.click_percent  = Math.round((x.email_clicks / x.count) * 100);

                        return x;
                    }));

                self.email_template_list_open_rate(data.email_template_list);
            },
            error: function (data) {
                self.error(data.statusText);
            }
        });

    };
    self.lookup_emails = function(){
        self.rootvm.is_busy(true);

        if(self.end_date() == ''){
            self.end_date(undefined)
        }
        if(self.start_date() == ''){
            self.start_date(undefined)
        }
        if(self.limit() == -1 || self.limit() == ""){
            self.limit(undefined);
        }


        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/email-list',
            type: 'GET',
            data:{
                search: self.search_name(),
                start_date: self.start_date(),
                end_date: self.end_date(),
                email_templates: self.selected_templates(),
                offset: self.offset(),
                limit:  self.limit()
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.emails(ko.utils.arrayMap( data.emails || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new Email(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);
                self.email_open_count(data.email_open_count);
                self.email_click_count(data.email_click_count);

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.filtered_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });

    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));
        if(self.offset() < 0){
            self.offset(0);
        }

        self.lookup_emails().then(function(){
            pager.navigate("#community/email-list"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_emails().then(function(){
            pager.navigate("#community/email-list"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };


};
